import { createAction } from '@reduxjs/toolkit'
import { ModalState } from './modal-add-fields.reducer'

export const setModalAddFieldsVisible = createAction<boolean>('modalAddFields/setModalAddFieldsVisible')
export const showModalAddFields = createAction<ModalState>('modalAddFields/showModalAddFields')
